module.exports = __webpack_public_path__ + "img/tree.72ba7006.png";